<template>
<div class="w-full">
<div style="padding:56.25% 0 0 0;position:relative;"><iframe src="https://vimeo.com/event/168142/embed" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen style="position:absolute;top:0;left:0;width:100%;height:100%;"></iframe></div>
</div>
</template>
